function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#1B1B1B",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M26 58c2.21 0 4 1.791 4 4 0 2.21-1.79 4-4 4-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4z",
  transform: "translate(2 2)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M40.724 57.272l-1.595-3.604-4.077 1.294c-.698-.92-1.541-1.718-2.495-2.369l1.03-4.141L29.918 47l-1.958 3.748c-1.144-.16-2.305-.13-3.438.087l-2.205-3.647-3.584 1.6 1.232 4.081c-.916.701-1.716 1.545-2.363 2.5l-4.15-1.018L12 58.027l3.744 2.005c-.148 1.147-.113 2.308.1 3.443l-3.64 2.209 1.596 3.589 4.003-1.234c.705.918 1.552 1.718 2.51 2.367l-1.029 4.141L22.953 76l2.104-3.792c1.145.147 2.304.112 3.438-.101l2.191 3.66 3.597-1.612-1.233-4.07c.918-.703 1.717-1.552 2.365-2.512l4.134 1.032L41 64.928l-3.757-2.004c.159-1.15.13-2.319-.087-3.458l3.568-2.194zM43.5 33c1.932 0 3.5 1.567 3.5 3.501C47 38.434 45.432 40 43.5 40c-1.933 0-3.5-1.566-3.5-3.499C40 34.567 41.567 33 43.5 33z",
  transform: "translate(2 2)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M56.753 33.21l-1.432-3.231-3.653 1.158c-.628-.823-1.382-1.54-2.237-2.122l.923-3.713L47.064 24l-1.757 3.36c-1.024-.143-2.065-.116-3.082.078l-1.977-3.27-3.212 1.434 1.105 3.66c-.822.628-1.539 1.384-2.12 2.24l-3.72-.911L31 33.886l3.357 1.799c-.133 1.027-.102 2.068.09 3.086l-3.264 1.981 1.43 3.217 3.59-1.108c.63.825 1.39 1.543 2.25 2.124l-.924 3.713L40.821 50l1.885-3.4c1.027.133 2.067.101 3.084-.09l1.963 3.283 3.225-1.447-1.105-3.648c.823-.632 1.538-1.392 2.119-2.253l3.708.925 1.3-3.296-3.368-1.797c.142-1.03.116-2.079-.079-3.1l3.2-1.967zM1 14.5h63M21 7.5h23",
  transform: "translate(2 2)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M57.19 99H7.81C3.497 99 0 95.53 0 91.252V7.748C0 3.47 3.497 0 7.809 0H57.19C61.504 0 65 3.47 65 7.748v83.504C65 95.53 61.504 99 57.19 99zM2 86.5h62",
  transform: "translate(2 2)"
}));

var SvgBluetoothModule06 = function SvgBluetoothModule06(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 103,
    viewBox: "0 0 69 103",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBluetoothModule06, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bluetooth-module-06.ab223e89.svg";
export { ForwardRef as ReactComponent };